// extracted by mini-css-extract-plugin
export default {"header":"ExploreDetailsHeader-module__header__e55eg","fakeExploreHeader":"ExploreDetailsHeader-module__fakeExploreHeader__M6qtg","tabs":"ExploreDetailsHeader-module__tabs__z3anY"};